module.exports = __webpack_public_path__ + "static/img/modal.6782e085.png";